import { CodeBlock } from "@/components/common/CodeBlock";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function HowToStartContent() {
  return (
    <Tabs defaultValue="linux">
      <TabsList>
        <TabsTrigger value="linux">Linux</TabsTrigger>
        <TabsTrigger value="windows" disabled>
          Windows (later)
        </TabsTrigger>
        <TabsTrigger value="macos" disabled>
          macOS (later)
        </TabsTrigger>
      </TabsList>
      <TabsContent value="linux" className="flex flex-col gap-3 pt-3">
        <p>Open a terminal in the folder where you extracted ATS and run:</p>
        <CodeBlock code="./bin/ats start" copyLabel="Copy command" />
        <p>Ready looks like this. The page connects by itself within a few seconds:</p>
        <CodeBlock code={"READY  ATS 0.1.0  Tester API http://localhost:7050"} copyLabel="Copy output" />
        <p className="text-sm text-muted-foreground">
          If ATS reports that port 7050 is in use, another program holds it. Find it with{" "}
          <code className="font-mono">ss -ltnp | grep 7050</code>, stop it, then run <code className="font-mono">ats start</code> again. ATS
          never picks another port.
        </p>
      </TabsContent>
    </Tabs>
  );
}

export function HowToStartDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Start the ATS runtime</DialogTitle>
          <DialogDescription>Runs execute on your computer. Start the runtime there, then come back to this page.</DialogDescription>
        </DialogHeader>
        <HowToStartContent />
      </DialogContent>
    </Dialog>
  );
}
